import outletPagesListSaga from './list'

export {outletPagesListSaga}



// WEBPACK FOOTER //
// ./app/sagas/outletPages/index.js